import AnalyteModel from "@/models/lab/AnalyteModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class AnalyteCollection extends LabServiceCollection {

  model() {
    return AnalyteModel;
  }

}
